module.exports = __webpack_public_path__ + "static/media/islamic-friends-hands-stack-for-teamwork-W86SFUQ-min.2b24cf7e.jpg";